/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { lAC_AddGratuityWithCrossChannelProfileAsync } from '../custom-actions/DataActionExtension.g';
import { IAddGratuityResponse, ILAC_AuthToken } from '../custom-actions/DataServiceEntities.g';
import { withFreshToken } from '../utils/authService';

/**
 * AddGratuity Input Action
 */
export class AddGratuityInput implements Msdyn365.IActionInput {
    public authTokenCookie: ILAC_AuthToken;
    public transactionId: string;
    public amount: number;
    public channelId: number;
    public customerId: string;

    constructor(transactionId: string, amount: number, channelId: number, customerId: string, authTokenCookie: ILAC_AuthToken) {
        this.authTokenCookie = authTokenCookie;
        this.transactionId = transactionId;
        this.amount = amount;
        this.channelId = channelId;
        this.customerId = customerId;
    }

    // a cache object type and an appropriate cache key
    public getCacheKey = () => `ADDGRATUITYWITHCROSSCHANNELPROFILE${this.transactionId}_${this.amount}_${this.channelId}`;
    public getCacheObjectType = () => 'ADDGRATUITYWITHCROSSCHANNELPROFILE';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

/**
 * Add gratuity to transaction
 */
async function addGratuityAsync(input: AddGratuityInput, ctx: Msdyn365.IActionContext): Promise<IAddGratuityResponse | undefined> {
    try {
        const result = await withFreshToken(ctx, input.authTokenCookie, async carried =>
            lAC_AddGratuityWithCrossChannelProfileAsync(
                { callerContext: ctx },
                carried,
                input.transactionId,
                input.amount,
                input.channelId,
                input.customerId
            )
        );
        if (result) {
            return result;
        }
    } catch (error) {
        console.error('Error adding gratuity:', error);
        throw error;
    }
    return undefined;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IAddGratuityResponse | undefined>>addGratuityAsync,
    id: 'AddGratuityWithCrossChannelProfile'
});
